<template>
  <ul class="vehicle-tree" role="tree">
    <li
      v-for="node in tree"
      :key="node.id"
      role="treeitem"
      :style="nodeMargin"
      :class="['vehicle-tree__item', {'vehicle-tree__item--indent': hasIndentation}]">
      <div :class="['vehicle-tree__content', {'vehicle-tree__content--disabled': !node.customModel}]">
        <button class="vehicle-tree__open" :disabled="!node.customModel" @click="openEditModal(node)">
          <span>{{ `${node.name}${!node.customModel ? '*' : ''}` }}</span>
          &nbsp;
          <span class="vehicle-tree__label">{{ node.label }}</span>
        </button>
        <oie-base-action v-if="node.children.length > 0" theme="flat" @click="toggleActiveChild(node)">
          <oie-base-icon icon="chevron-down" size="xs" :rotate="isActive(node) ? '180' : ''"></oie-base-icon>
        </oie-base-action>
      </div>
      <template v-if="isActive(node)">
        <oie-vehicle-tree :nodes="node.children" :spacing="25"></oie-vehicle-tree>
      </template>
    </li>
  </ul>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'

export default {
  props: {
    spacing: { type: Number, default: 0 },
    nodes: { type: Array, default: null }
  },
  data() {
    return {
      activeChildren: []
    }
  },
  computed: {
    ...mapGetters('myMachines', ['customVehicles']),
    tree() {
      return this.nodes ? this.nodes : this.customVehiclesAsNodes
    },
    nodeMargin() {
      return {
        'margin-left': `${this.spacing}px`
      }
    },
    hasIndentation() {
      return this.spacing > 0
    },
    customVehiclesAsNodes() {
      const allVehicles = _.cloneDeep(this.customVehicles)
      _.forEach(allVehicles, type => {
        type.children = type.brands
        type.label = this.t('vehicleTypeHeading')
        _.forEach(type.brands, brand => {
          brand.children = brand.models
          brand.label = this.t('vehicleBrandHeading')
          _.forEach(brand.models, model => {
            model.children = []
            model.label = this.t('vehicleModelHeading')
          })
        })
      })

      return allVehicles
    }

  },
  methods: {
    toggleActiveChild(child) {
      const index = _.findIndex(this.activeChildren, c => c.id === child.id)
      if(index === -1) {
        this.activeChildren.push(child)
      } else {
        this.activeChildren.splice(index, 1)
      }
    },
    isActive(child) {
      return _.some(this.activeChildren, c => c.id === child.id)
    },
    openEditModal(node) {
      this.publish('modal.show.edit-custom-machine', { node: node })
    }
  }
}
</script>

<style lang="scss">
.vehicle-tree {
  @include reset-list;
}

.vehicle-tree__item {
  position: relative;
}

// STYLES FOR BLUE "HIERARCHY" LINES - Start --------------

.vehicle-tree__item--indent::before {
  content: '';
  position: absolute;
  left: -13px;
  width: 2px;
  height: 100%;
  display: block;
  background: color(brand-blue-3);
}

.vehicle-tree__item--indent::after {
  content: '';
  position: absolute;
  top: 24px;
  left: -13px;
  width: 15px;
  height: 2px;
  display: block;
  background: color(brand-blue-3);
}

.vehicle-tree__item--indent:last-child::before {
  top: 0;
  height: 24px;
}

// STYLES FOR BLUE "HIERARCHY" LINES - End --------------

.vehicle-tree__content {
  display: flex;
  gap: measure(quarter);
  align-items: center;
  justify-content: space-between;
  height: 50px;
  width: 100%;
  padding: measure(quarter) 0 measure(quarter) measure(quarter);
}

.vehicle-tree__content:not(.vehicle-tree__content--disabled) {
   &:hover {
    background-color: color(gray-6);
  }

  &:hover > .vehicle-tree__open >:first-child {
    text-decoration: underline;
  }
}

.vehicle-tree__open {
  @include reset-button;
  @include h3;
}

.vehicle-tree__open:disabled {
  cursor: default;
}

.vehicle-tree__open::after {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.vehicle-tree__label {
  @include caption;
  color: color(gray-2);
}
</style>
